import {
  OverlayTrigger,
  OverlayTriggerProps,
  Tooltip,
  TooltipProps,
} from 'react-bootstrap'

import styled from 'styled-components'

type Props = Pick<OverlayTriggerProps, 'children' | 'delay' | 'placement'> &
  Pick<TooltipProps, 'title'>

const StyledTooltip = styled(Tooltip)`
  &.show {
    opacity: 1;
  }

  > .tooltip-inner {
    background-color: #fff;
    color: #000;
    opacity: 1;
  }

  > .tooltip-arrow::before {
    border-color: #fff;
  }
`

export function LightTooltip({
  title,
  placement,
  delay,
  children,
}: Readonly<Props>) {
  return (
    <OverlayTrigger
      delay={delay}
      placement={placement}
      overlay={<StyledTooltip placement={placement}>{title}</StyledTooltip>}
    >
      {children}
    </OverlayTrigger>
  )
}
